module.exports = __webpack_public_path__ + "img/PR.212232ee.png";